<template>
  <div v-if="is_open">
    <div class="gallery-overlay">
      <div class="gallery-container">
        <div class="gallery-container__header">
            <h5 class="position-relative">{{ title }}</h5>
            <a class="button-close" @click.prevent="clear()"><img src="/img/close.svg" alt="close" class="close-icon"></a>
        </div>
        <p class="text-primary gallery-container__description">{{ description }}</p>
        <div class="gallery-container__body">
            <div v-for="(photo, index) in photos"  class="gallery-photo-container" :key="index" :class="{ selected : selected == photo.id}" @click.prevent="selected = photo.id">
                <div class="gallery-photo-container__placeholder"><img :src="getThumbnail(photo)" alt=""></div>
                <p class="gallery-photo-container__title">{{ photo.name }}</p>
            </div>
        </div>

        <div class="gallery-container__footer d-flex">
            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="clear()">{{ $t('common.cancel') }}</button>
            <button :disabled="!selected" class="button button-m button-primary" @click.prevent="select()">{{ $t('common.select') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            listing_id: Number
        },
        data() {
            return {
                title: '',
                description: '',
                type: '',
                is_open: false,
                photos: [],
                selected: false
            }
        },
        mounted() {
            this.getListingPhotos()
        },
        methods: {
            getSelectedPhoto() {
                return this.photos[this.photos.findIndex(item => item.id === this.selected)]
            },
            select() {
                this.$root.$emit('photo_selected', this.type, this.getSelectedPhoto())

                let url = `/api/media/set-photo/${this.listing_id}`;

                axios.patch(url, {
                    type: this.type,
                    id: this.selected
                })

                this.clear();
            },
            clear() {
                this.is_open = false;
                this.type = '';
                this.selected = false;
                this.title = "";
                this.description = "";
            },
            getListingPhotos() {
                let url =  `/api/photos/get-listing/${this.listing_id}`;

                return axios.get(url)
                    // get data
                    .then(function (response) {
                        // handle success
                        this.photos = response.data.data.photos;
                    }.bind(this));
            },
            getThumbnail(photo) {
                return photo.thumb_path ? photo.thumb_path : photo.full_path;
            }
        }
    }
</script>
